import { service, service_Go } from '../../service';

const state = {
  currentSkin:
    process.env.LAYOUT && process.env.LAYOUT.NAME ? process.env.LAYOUT.NAME : 'fullWidth', // ['default', 'sideNav', 'fullWidth']
  VIDEO_HD: process.env.LAYOUT ? process.env.LAYOUT.VIDEO_HD : true, // [false, true]
  navigation:
    process.env.LAYOUT && process.env.LAYOUT.NAVIGATION
      ? process.env.LAYOUT.NAVIGATION
      : 'hasCarousel', // ['hasCarousel', 'hasCategories', 'hasScroll']
  components: {
    searchInput:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.SEARCH_INPUT
        ? process.env.LAYOUT.COMPONENTS.SEARCH_INPUT
        : 'default', // ['default', 'rounded']
    navBar:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.NAV_BAR
        ? process.env.LAYOUT.COMPONENTS.NAV_BAR
        : 'default', // ['default', 'reverse']
    header:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.HEADER
        ? process.env.LAYOUT.COMPONENTS.HEADER
        : 'default', // ['default', 'large','info']
    options:
      process.env.LAYOUT && process.env.LAYOUT.COMPONENTS.OPTIONS
        ? process.env.LAYOUT.COMPONENTS.OPTIONS
        : 'default', // ['default','info','tv','formation']
  },
  currentPrimaryColor: '',
  currentSecondaryColor: '',
  currentLogo: '',
  currentSkinPlayer: '',
  isSiteEmbed: false,
};

const mutations = {
  SET_CURRENT_Skin(state, currentSkin) {
    state.currentSkin = currentSkin;
  },
  SET_CURRENT_Primary_Color(state, currentPrimaryColor) {
    state.currentPrimaryColor = currentPrimaryColor;
  },
  SET_CURRENT_Secondary_Color(state, currentSecondaryColor) {
    state.currentSecondaryColor = currentSecondaryColor;
  },
  SET_CURRENT_Logo(state, currentLogo) {
    state.currentLogo = currentLogo;
  },
  SET_CURRENT_Skin_Player(state, currentSkinPlayer) {
    state.currentSkinPlayer = currentSkinPlayer;
  },
  SET_IS_SITE_EMBED(state, isSiteEmbed) {
    state.isSiteEmbed = isSiteEmbed;
  },
};

const actions = {
  setIsSiteEmbed({ commit }, is) {
    commit('SET_IS_SITE_EMBED', is);
  },
  setCurrentSkin({ commit }, currentSkin) {
    commit('SET_CURRENT_Skin', currentSkin);
  },
  setCurrentPrimaryColor({ commit }, currentPrimaryColor) {
    commit('SET_CURRENT_Primary_Color', currentPrimaryColor);
  },
  setCurrentSecondaryColor({ commit }, currentSecondaryColor) {
    commit('SET_CURRENT_Secondary_Color', currentSecondaryColor);
  },
  setCurrentLogo({ commit }, currentLogo) {
    commit('SET_CURRENT_Logo', currentLogo);
  },
  setCurrentSkinPlayer({ commit }, currentSkinPlayer) {
    commit('SET_CURRENT_Skin_Player', currentSkinPlayer);
  },
  async fetchCurrentSkin({ commit }) {
    /*const { data } = await service.getCurrentSkin({
      id: 139,
    });
    const currentSkin = data.data.value;
    commit('SET_CURRENT_Skin', currentSkin);*/
  },
  async fetchTemplateOptions({ commit }, id) {
    const { data } = await service_Go.getTemplateOptions(id);
    try {
      let options = data.templatesOptions[0];
      let objectColors = JSON.parse(options.colors);
      commit('SET_CURRENT_Primary_Color', objectColors.primary_color);
      commit('SET_CURRENT_Secondary_Color', objectColors.secondary_color);
      commit('SET_CURRENT_Logo', options.logo);
      commit('SET_CURRENT_Skin_Player', options.skin_player);
    } catch (e) {}
  },
};

const getters = {
  getIsSiteEmbed: state => state.isSiteEmbed,
  getCurrentSkin: state => state.currentSkin,
  getNavigation: state => state.navigation,
  isFullWidth: state => state.currentSkin === 'fullWidth',
  isSideNav: state => state.currentSkin === 'sideNav',
  hasCarousel: state => state.navigation === 'hasCarousel',
  hasCategories: state => state.navigation === 'hasCategories',
  hasScroll: state => state.navigation === 'hasScroll',
  isHeaderInfo: state => state.components.header === 'info',
  hasOptions: state => state.components.options === 'info',
  hasOptionsTv: state => state.components.options === 'tv',
  hasOptionsFormation: state => state.components.options === 'formation',
  getIsVideoHd: state => state.VIDEO_HD,
  getComponentStyle: state => state.components,
  getCurrentPrimaryColor: state => state.currentPrimaryColor,
  getCurrentSecondaryColor: state => state.currentSecondaryColor,
  getCurrentLogo: state => state.currentLogo,
  getCurrentSkinPlayer: state => state.currentSkinPlayer,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/layouts.js